/**
 * Internal dependencies
 */
import { getAlternative } from './alternative';
import { addQueryArgs } from '../utils/url';

export function getExpectedAlternativeUrl( settings ) {
	const { numOfAlternatives, untestedUrl } = settings;
	const alternative = getAlternative( settings );
	const nab = alternative % numOfAlternatives;
	return numOfAlternatives
		? addQueryArgs( untestedUrl, { nab } )
		: untestedUrl;
} //end getExpectedAlternativeUrl()
